/**
 * Display labels for a global attribute's provenance (`GlobalAttrFlavor`).
 *
 * The raw flavor ("eng" | "user") is data, not copy: anything the user reads or
 * types against — grid cells, grid filters, modal banners — must resolve through
 * this one mapping or the surfaces drift apart (a grid filter matching "eng"
 * while the cell next to it reads "Eng-validated").
 */
import type { GlobalAttrFlavor } from "#common/types/vault";

/** Human-facing label for a global attribute's provenance. */
export const globalAttrFlavorLabel = (flavor: GlobalAttrFlavor): string =>
  flavor === "user" ? "User-created" : "Eng-validated";
